import progressBar from "../../../../src/projects/portshowlio-2020/images/ss/progress-bar.svg";
import { Ticker } from "../../../../src/projects/portshowlio-2020/images/ss/Ticker";
import * as React from 'react';
export default {
  progressBar,
  Ticker,
  React
};